import { LeftHandSidePageProjectDetails } from "../../../../onboarding-wizard/wizard/page-project-details/left-hand-side/left-hand-side";
import { StepContext, StepProps } from "../../../types";

export const SpaceDetails = <T extends StepContext>({
    context,
    setContext,
    nextStep
}: StepProps<T>) => {
    const handleSpaceNameChange = (spaceName: string) => {
        setContext(
            (prevContext: T | undefined) =>
                ({
                    ...(prevContext ?? {}),
                    spaceName
                } as T)
        );
    };

    return (
        <LeftHandSidePageProjectDetails
            currentProjectName={undefined}
            defaultProjectName={context?.spaceName ?? ""}
            onProjectNameChange={handleSpaceNameChange}
            onClickNext={nextStep}
        />
    );
};
